import React from 'react';
import '../App.css'
class AuthorP extends React.Component {
    constructor(props){
        super(props);
    }
    render(){
        const linkStyle ={ width:"33px", height:"33px"};
        return (
            <div className="Home-main">
                <div className="d-flex container">
                    <div className="box text-white">
                        <div className="card bg-dark">
                            <div className="card-body">
                                <h4 className="card-title text-center">Vinayak <i>Vasudev</i></h4>
                                <div className="card-text row">
                                    <p>
                                    Here’s the things I know for certain. <br/>
                                    I love learning. and it sometimes gets frustrating when the understanding isn’t clear but what’s to stop me from <i>tinkering?</i> <br/>
                                    </p>
                                    <div className="box">
                                        <h4>Proffesional niche</h4>
                                        <p>Transforming legacy web systems to SPA architecture, at times with just pure JS, without breaking the back button.</p>
                                        <p></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default AuthorP;